import React from "react";
import { Badge, Button } from "reactstrap";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";
import { BULK_MODULE_CODE } from "../Json/BulkUploadConfigJson";
import { BULK_UPLOAD_MESSAGES } from "../Json/BulkUploadMessages";

const { table } = BULK_UPLOAD_MESSAGES;

const COLUMN_SIZE = {
  type: 260,
  description: 520,
  template: 140,
  upload: 140,
};

/**
 * Columns for the bulk upload listing.
 *
 * @param {(config: object) => void} onUploadClick  Opens the upload modal.
 * @param {Object<string, string>} templates  Template URL per config templateKey.
 */
const useBulkOrderColumns = (onUploadClick, templates = {}) => {
  const canUpload = checkButtonAccess("CREATE", BULK_MODULE_CODE);

  const bulkOrderColumns = [
    {
      header: table.typeColumn,
      accessorKey: "title",
      size: COLUMN_SIZE.type,
      cell: (props) => {
        const config = props.row.original;
        return (
          <div className="d-flex align-items-center gap-2">
            <i className={`${config.icon} text-muted align-bottom`} />
            <span>{config.title}</span>
            <Badge color={config.badge.color} className="fw-medium">
              {config.badge.text}
            </Badge>
          </div>
        );
      },
    },
    {
      header: table.descriptionColumn,
      accessorKey: "description",
      size: COLUMN_SIZE.description,
      cell: (props) => (
        <span className="text-muted">{props.getValue() || "-"}</span>
      ),
    },
    {
      header: table.templateColumn,
      accessorKey: "template",
      size: COLUMN_SIZE.template,
      cell: (props) => {
        const templateUrl = templates[props.row.original.templateKey];
        return templateUrl ? (
          <Button
            tag="a"
            href={templateUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="secondary"
            size="sm"
            outline
          >
            <i className="ri-download-2-line me-1" />
            {table.templateAction}
          </Button>
        ) : (
          "-"
        );
      },
    },
    {
      header: table.uploadColumn,
      accessorKey: "upload",
      size: COLUMN_SIZE.upload,
      cell: (props) =>
        canUpload ? (
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => onUploadClick(props.row.original)}
          >
            <i className="ri-upload-cloud-2-line me-1" />
            {table.uploadAction}
          </Button>
        ) : (
          "-"
        ),
    },
  ];

  return { bulkOrderColumns };
};

export default useBulkOrderColumns;
